'use strict';

const i18n = require('i18next');
const Moment = require('moment');
const _ = require('underscore');
const Mn = require('backbone.marionette');
const Template = require('../../template/modal/announcement.hbs');
const AnnouncementFactory = require('feedback/domain/factory/announcement');
const AnnouncementCategory = require('feedback/domain/value/announcement-category');
const AnnouncementEntity = require('feedback/domain/entity/announcement');
const ReleaseNoteEntity = require('feedback/domain/entity/release-note');
const IdeaSelectView = require('feedback/ui/view/admin/idea/selector');
const MarkdownWriterView = require('common/ui/view/markdown/writer');

require('backbone.stickit');

const AnnouncementEditModal = Mn.View.extend({
    template: Template,
    regions: {
        ideaSelector: '.ideaSelector',
        writer: '.description-writer',
    },
    bindings: {
        'input.title': 'title',
        'select.state': {
            observe: 'state',
            selectOptions: {
                collection: function () {
                    return _.map(this.model.getStateChoices(), s => {
                        return {
                            value: s,
                            label: i18n.t(`feedback:announcement.state.${s}`)
                        }
                    });
                }
            }
        },
        'select.category': {
            observe: 'categoryName',
            selectOptions: {
                collection: function () {
                    return _.map(AnnouncementCategory.getChoices(), s => {
                        return {
                            value: s,
                            label: i18n.t(`feedback:announcement.category.${s}`)
                        }
                    });
                }
            }
        },
        'input.expired-at': 'expiredAt'
    },

    templateContext: function() {
        return {
            isEditing: this.getOption('isEditing'),
            isReleaseNote: this.isReleaseNote()
        }
    },

    initialize: function() {
        const isEditing = this.getOption('isEditing');
        if(isEditing) {
            this.model = this.model.clone();
            const expiredAt = this.model.getExpiredAt();
            if(expiredAt) {
                this.model.set('expiredAt', Moment(expiredAt).format('YYYY-MM-DDTHH:mm'));
            }
        }else{
            this.model = new AnnouncementEntity();
        }
    },

    onRender: function() {
        if(this.isReleaseNote()) {
            const ideaKeys = _.map(this.model.getIdeaKeys(), key => {
                return key.id;
            });

            this.showChildView('ideaSelector', new IdeaSelectView({
                states: ['releaseWaiting'],
                ideaKeys: ideaKeys
            }));
        }

        const writer = new MarkdownWriterView({
            markdown: this.model.getDescription()
        });
        this.showChildView('writer', writer);
        this.listenTo(writer, 'change', (desc) => {
            this.model.set('description', desc);
        });

        this.listenTo(this.model, 'change:categoryName', (model) => {
            new AnnouncementFactory()
                .build(model.toJSON())
                .then(rebuildModel => {
                    this.model = rebuildModel;
                    this.render();
                });
        });

        this.listenTo(this.model, 'change', this._filledCheck);
        this.stickit();
        return this;
    },

    _filledCheck: function() {
        if (this.model.isFilled()) {
            this.trigger('formFilled');
        } else {
            this.trigger('formEmpty');
        }
    },

    getAttributes: function() {
        let attr = {
            title: this.model.getTitle(),
            description: this.model.getDescription(),
            state: this.model.getState(),
            categoryName: this.model.getCategoryName(),
            expiredAt: Moment(this.model.getExpiredAt(), Moment.ISO_8601)
        };
        if(this.isReleaseNote()) {
            attr.ideas = this.getChildView('ideaSelector').getSelectedIdeaKeys()
        }
        return attr;
    },

    isReleaseNote: function() {
        return this.model instanceof ReleaseNoteEntity;
    }
});

module.exports = AnnouncementEditModal;



// WEBPACK FOOTER //
// ./feedback/ui/view/modal/announcement.js